import React, { useState } from 'react'
import { AllReservesComponent } from '../Components/Reserves/AllReservesComponent';
import { AReserveFoodsAndParking_Step1_Component } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking_Step1_Component';
import { AReserveFoodsAndParking } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking';

export const FoodReserve = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [selectedId, setSelectedId] = useState(0);
    // ======================================================================
    return (
        <>
            {view == "All" ?
                <AllReservesComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    forCurrentUser={true}
                    onlyByFoodOrParking={true}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onItemClick={(id) => { setSelectedId(id); setView('AFoodReserve') }}
                    // isShowFoodReserve={false}
                /> : <></>}
            {view == "AFoodReserve" ?
                <AReserveFoodsAndParking
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedId}
                    onBackClick={() => { setView('All') }}
                    onPayCompleted={() => { setView('All') }}
                /> : <></>}
        </>
    )
}
